<template>
	<div
		:class="{
			replies: showReplyBox
		}">
		<div>
			<div v-if="showReplyBox" class="d-flex justify-space-between align-center" :class="{ 'mt-6': display.mdAndUp.value }">
				<div class="heading" :class="{ 'heading-mobile': display.smAndDown.value }">Replies</div>
				<v-btn v-if="!isCloseButtonHidden" class="item right" icon @click="openReplyBox">
					<v-icon v-if="display.smAndDown.value">icon-close-large</v-icon>
					<v-icon v-else>icon-close-medium</v-icon>
				</v-btn>
			</div>
			<v-list-item v-if="!isEditing" class="pa-0" :class="{ 'row-updated': comment.$updated }">
				<div class="comment w-100">
					<div class="d-flex justify-space-between mt-2">
						<div class="d-flex number-container justify-space-between">
							<div class="d-flex align-center flex-shrink-1" style="min-width: 0">
								<v-avatar
									v-test="'comment-avatar-action'"
									:color="getColor(commentData.User?.Account?.avatarColor)"
									class="mr-2">
									<span
										class="team-avatar-text"
										:style="{ color: getReadableInitialsColor(commentData.User?.Account?.avatarColor) }"
										>{{ getAgentNameInitials(setStartedByColum(commentData)) }}</span
									>
								</v-avatar>
								<span class="chip-text text-150">{{ setStartedByColum(commentData) }}</span>
								<div class="date">{{ getDisplayDate(commentData) }}</div>
							</div>
							<v-menu
								v-if="
									isMyComment &&
									!commentData.deletedAt &&
									!isViewOnly &&
									!isEditing &&
									!isCommentBeingEdited &&
									!isEditingReply
								"
								v-model="moreOptionsOpened"
								minWidth="114"
								class="mr-1 flex-shrink-0"
								:transition="false"
								:z-index="10000">
								<template #activator="{ props }">
									<v-btn
										v-bind="props"
										v-test="'more-options'"
										v-track="'more-options-button'"
										icon="icon-dots-horizontal-more"
										density="comfortable"
										variant="plain"
										elevation="0"
										class="mr-2"></v-btn>
								</template>
								<v-list rounded="lg" class="more-actions pa-2">
									<v-list-item class="hover-item" @click="toggleEditComment" rounded="pill">
										<v-btn
											v-if="isMyComment"
											v-show="me?.id != commentData.User?.id"
											class="no-pointer-events"
											elevation="0"
											color="transparent">
											<v-icon class="mr-2">icon-pencil-edit-stroke</v-icon>
											<span>Edit</span>
										</v-btn>
									</v-list-item>
									<v-list-item class="hover-item" rounded="pill" @click="() => deleteComment(commentData.id, isReply)">
										<v-btn
											v-if="isMyComment"
											v-show="me?.id != commentData.User?.id"
											class="no-pointer-events"
											elevation="0"
											color="transparent">
											<v-icon class="mr-2" color="red">icon-trash-full-stroke</v-icon>
											Delete
										</v-btn>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</div>
					<div class="comment-size mx-14">
						<div class="d-flex">
							<div class="comment-name">
								<span
									v-for="(comment, idx) in getCommentParts()"
									:key="idx"
									class="body"
									:class="{ mention: idx % 2 === 1 }"
									:style="idx % 2 == 1 ? 'white-space: pre;' : ''">
									{{ comment }}
								</span>
							</div>
						</div>

						<div class="d-flex team-member comment-row">
							<v-btn
								v-if="!isReply && !showReplyBox && !commentData.deletedAt && !isViewOnly"
								variant="plain"
								class="pa-0 ma-0 justify-start"
								slim
								@click="openReplyBox">
								<span>Reply</span>
							</v-btn>
						</div>
						<v-btn v-if="totalReplies > 0 && !showReplyBox" elevation="0" @click="openReplyBox">
							{{ buttonLabel }}
						</v-btn>
					</div>
				</div>
			</v-list-item>
			<v-list-item v-else class="editing-comment ml-2" :class="{ 'row-updated': commentData.$updated }">
				<div class="w-100">
					<AddComment
						class="mt-2"
						:project-id="projectId"
						:project-share-users="projectShareUsers"
						:edit-comment="commentData"
						:users="users"
						:light-box-view="lightBoxView"
						@show-lucky="showLucky"
						@hide-lucky="hideLucky"
						@closeEdit="toggleEditComment"
						@update:editComment="updateComment"
						@update:addComment="updateComment"
						@comment-edited="onCommentEdited"
						@cancelReply="openReplyBox" />
				</div>
			</v-list-item>
		</div>

		<!--- Show count of replies below card  --->

		<div v-if="showReplyBox" class="d-flex flex-column reply-and-replies">
			<AddComment
				v-if="showReplyBox && !isEditing && !isViewOnly"
				ref="replyBoxAddComment"
				class="full-width d-flex flex-column my-2"
				:placeholder="replyBoxPlaceholder"
				:disable-new-reply="Boolean(commentData.deletedAt)"
				:project-id="projectId"
				:project-share-users="projectShareUsers"
				:light-box-view="lightBoxView"
				:is-reply="true"
				:users="users"
				@show-lucky="showLucky"
				@hide-lucky="hideLucky"
				@update:addComment="addComment"
				@comment-edited="onCommentEdited"
				@cancelReply="openReplyBox" />
			<div v-if="totalReplies > 0" class="replies-line d-flex" style="flex: 0 0 auto">
				<div>{{ totalReplies }} {{ totalReplies > 1 ? "replies" : "reply" }}</div>
				<div class="line"></div>
			</div>
			<div class="d-flex flex-column" :class="getContainerClass" style="flex: 1 1 auto">
				<CommentAction
					v-for="reply in replies"
					:key="reply.id"
					:is-view-only="isViewOnly"
					:me="me"
					:users="users"
					:project-share-users="projectShareUsers"
					:comment="reply"
					:is-reply="true"
					:user-map="userMap"
					:is-comment-being-edited="isEditingReply || isCommentBeingEdited"
					:light-box-view="lightBoxView"
					@show-lucky="showLucky"
					@hide-lucky="hideLucky"
					@edit-comment="editReply"
					@comment-edited="onCommentEdited"
					@delete-comment="() => deleteComment(reply.id)" />
			</div>
		</div>
	</div>
</template>

<script>
	import api from "@/api";
	import AddComment from "./AddComment.vue";
	import { setStartedByColumn, getAgentNameInitials, getDisplayDate, getColor, getReadableInitialsColor } from "../helpers/utilities";
	import EventBus from "@/helpers/eventBus";
	import { formatCommentMentions } from "@/formatters/comments";
	import { calculateTimeout } from "@/helpers/utilities";
	import { logError, logWarn } from "@/helpers/logError";
	import { useDisplay } from "vuetify";
	import { useToast } from "vue-toastification";

	export default {
		name: "CommentAction",
		components: {
			AddComment
		},
		setup() {
			const display = useDisplay();
			const toast = useToast();
			return { display, toast, getColor, getReadableInitialsColor };
		},
		props: {
			isCommentBeingEdited: {
				type: Boolean,
				default: false
			},
			isViewOnly: {
				type: Boolean,
				required: true
			},
			comment: {
				type: Object,
				required: true
			},
			isReply: {
				type: Boolean,
				default: false
			},
			me: {
				type: Object,
				required: false
			},
			users: {
				type: Array,
				required: true
			},
			lightBoxView: {
				type: Boolean,
				required: true
			},
			projectId: {
				type: String,
				default: null
			},
			projectShareUsers: {
				type: Array,
				default: () => []
			},
			userMap: {
				type: Map,
				default: () => new Map()
			}
		},
		data() {
			return {
				showReplyBox: false,
				isEditing: false,
				replies: [],
				isMyComment: false,
				isEditingReply: false,
				commentData: null,
				moreOptionsOpened: false,
				// LSP-17108 break-it round: bumped synchronously by every openReplyBox call (open
				// or close) and by unmounted(), so an in-flight getComments() from an earlier call
				// can recognize it has been superseded and discard its result instead of reopening/
				// re-toasting after the user has already closed, re-toggled, or navigated away.
				replyBoxRequestId: 0
			};
		},
		computed: {
			isCloseButtonHidden() {
				return this.isEditingReply || (this.isEditing && this.showReplyBox);
			},
			getContainerClass() {
				return {
					"height-full": this.showReplyBox && this.lightBoxView,
					"editing-reply": this.isEditingReply,
					"replies-container-mobile": this.display.smAndDown.value || this.lightBoxView
				};
			},
			buttonLabel() {
				return this.showReplyBox
					? "Hide Replies"
					: `--- View ${this.commentData.replyCount} ${this.commentData.replyCount > 1 ? "replies" : "reply"}`;
			},
			totalReplies() {
				return this.commentData.replyCount;
			},
			commentContent() {
				const allowedUsersMap = this.userMap;
				for (const user of this.comment.mentionedUsers ?? []) {
					allowedUsersMap.set(user.id, `${user.firstname} ${user.lastname}`);
				}
				return formatCommentMentions(this.comment.content, allowedUsersMap);
			},
			replyBoxPlaceholder() {
				return this.commentData.deletedAt ? "Replies are disabled." : "Got something to add? Reply here.";
			}
		},
		watch: {
			isCommentBeingEdited() {},
			comment: {
				handler() {
					this.commentData = this.comment;
				},
				deep: true
			},
			moreOptionsOpened: {
				handler() {}
			}
		},
		created() {
			this.commentData = this.comment;
		},
		async mounted() {
			if (!this.isViewOnly) {
				this.isMyComment = this.me?.user.id === this.comment.User.id;
			}

			// LSP-16267: guard with `showReplyBox` — `openReplyBox({})` is a toggle, so
			// without the guard a CommentAction whose reply box is closed would *open*
			// on the event (and trigger an API call to load that comment's replies).
			// Hoisted to an instance field (rather than an inline arrow) so beforeUnmount()
			// can pass the same reference to EventBus.$off — an anonymous closure can never be
			// unregistered. Mirrors AddComment.vue's _onUserRemovedFromProject/
			// _onProjectShareAccessChanged pattern for the same EventBus.
			this._onCloseReplies = () => {
				if (this.showReplyBox) {
					this.openReplyBox({});
				}
			};
			EventBus.$on("CloseReplies", this._onCloseReplies);
		},
		beforeUnmount() {
			if (this._onCloseReplies) {
				EventBus.$off("CloseReplies", this._onCloseReplies);
			}
			// LSP-17108 break-it round: invalidate any in-flight openReplyBox() request so a
			// getComments() that resolves/rejects after this instance is torn down cannot mutate
			// state or show a toast — see replyBoxRequestId above.
			this.replyBoxRequestId++;
		},
		methods: {
			editReply(replyData, isEditingReply) {
				this.isEditingReply = isEditingReply;
				this.replies = this.replies.map((c) => (c.id === replyData.id ? replyData : c));
			},
			toggleEditComment() {
				this.isEditing = !this.isEditing;
				this.moreOptionsOpened = false;
				this.$emit("edit-comment", this.commentData, this.isEditing);
			},
			showLucky() {
				this.$emit("show-lucky");
			},
			hideLucky() {
				this.$emit("hide-lucky");
			},
			getCommentParts() {
				if (this.commentData.deletedAt) return ["[Deleted]"];
				return this.commentContent.split("<split>");
			},
			getDisplayDate(comment) {
				return getDisplayDate(comment);
			},
			setStartedByColum(item) {
				if (!this.isViewOnly) {
					return setStartedByColumn(item, this.me?.user.id);
				}
				return setStartedByColumn(item, null);
			},
			getAgentNameInitials(agentName) {
				return getAgentNameInitials(agentName);
			},
			async updateComment(updatedComment) {
				try {
					this.commentData = await api.updateComment(this.commentData.id, { content: updatedComment });
					this.moreOptionsOpened = false;
					this.isEditing = false;
					this.$emit("edit-comment", this.commentData, this.isEditing);
					this.$emit("update-comment", this.commentData);
				} catch (error) {
					logError("Failed to update comment", error, {
						method: "updateComment",
						component: "CommentAction",
						commentId: this.commentData.id
					});
					const message = "Something went wrong updating the comment. Please try again.";
					this.toast.error(message, { timeout: calculateTimeout(message) });
				}
			},
			async deleteComment(commentId, isReply = false) {
				if (!isReply) {
					if (
						await this.$root.$confirm.deleteOpen(
							"You're about to delete a comment",
							"Are you sure? This comment will be removed."
						)
					) {
						try {
							await api.deleteComment(commentId);
							if (this.commentData.id !== commentId) {
								this.commentData.replyCount--;
								this.openReplyBox({ forced: this.commentData.replyCount > 0 });
							} else {
								this.$emit("delete-comment", commentId);
								if (this.showReplyBox) {
									this.openReplyBox({});
								}
							}
						} catch (error) {
							logError("Failed to delete comment", error, {
								method: "deleteComment",
								component: "CommentAction",
								commentId
							});
							const message = "Something went wrong deleting the comment. Please try again.";
							this.toast.error(message, { timeout: calculateTimeout(message) });
						}
					} else {
						return;
					}
				} else {
					this.$emit("delete-comment", commentId);
				}
			},
			async addComment(comment) {
				try {
					const reply = await api.createComment({
						parentId: this.commentData.id,
						parentType: "comment",
						content: comment
					});
					this.replies = [reply, ...this.replies];
					this.commentData.replyCount++;
				} catch (error) {
					logError("Failed to add comment reply", error, {
						method: "addComment",
						component: "CommentAction",
						parentId: this.commentData.id
					});
					const message = "Failed to add the comment.";
					this.toast.error(message, { timeout: calculateTimeout(message) });
				}
			},
			async openReplyBox({ forced }) {
				// LSP-17108 break-it round: bump the request id synchronously, before the network
				// call below, so ANY earlier in-flight openReplyBox() call — whether it's still
				// awaiting getComments() or about to run its catch — can tell it has been
				// superseded (by a close, another open, or unmount) and discard its result instead
				// of reopening the box or toasting after the fact.
				const requestId = ++this.replyBoxRequestId;
				if (forced || this.showReplyBox === false) {
					// Open branch: the only branch that touches the network. Its try/catch is scoped
					// to this branch alone (LSP-17108) so a close-time failure below can never be
					// mislabeled with this fetch-specific copy.
					try {
						if (this.isEditing) {
							this.toggleEditComment();
						}
						let replyResponse = await api.getComments({
							where: { parentId: this.commentData.id },
							order: [["createdAt", "DESC"]],
							pageSize: 50
						});
						if (requestId !== this.replyBoxRequestId) {
							// Expected race outcome (a later close/open/unmount superseded this
							// request), not an anomaly — logWarn, not logError.
							logWarn("[CommentAction] openReplyBox open: discarding stale getComments response", {
								component: "CommentAction",
								method: "openReplyBox",
								requestId,
								currentRequestId: this.replyBoxRequestId,
								commentId: this.commentData?.id
							});
							return;
						}
						this.replies = replyResponse.rows.filter((c) => c.deletedAt === null);
						this.replies = this.replies.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
						this.showReplyBox = true;
					} catch (error) {
						if (requestId !== this.replyBoxRequestId) {
							// Expected race outcome, not an anomaly — logWarn, not logError. The
							// original rejection is already moot (a later call superseded it), so
							// only its message is kept for context, not the full error render.
							logWarn("[CommentAction] openReplyBox open: discarding stale getComments rejection", {
								component: "CommentAction",
								method: "openReplyBox",
								requestId,
								currentRequestId: this.replyBoxRequestId,
								commentId: this.commentData?.id,
								errorMessage: error instanceof Error ? error.message : String(error)
							});
							return;
						}
						logError("Failed to load replies", error, {
							component: "CommentAction",
							method: "openReplyBox",
							commentId: this.commentData?.id
						});
						const message = "Something went wrong loading replies. Please try again.";
						this.toast.error(message, { timeout: calculateTimeout(message) });
						return;
					}
				} else {
					// Close branch: never touches the network, so it must never surface the
					// fetch-specific toast above. The user's close already happened (showReplyBox is
					// already false by the time we reach the composer cleanup), so a cleanup miss is
					// diagnostic-only — see closeReplyComposer().
					this.showReplyBox = false;
					if (this.commentData.deletedAt && this.commentData.replyCount === 0) {
						this.$emit("reduce-comment-count");
					}
					this.closeReplyComposer();
				}
				this.$emit("toggle-reply-box", this.showReplyBox, this.commentData.id);
			},
			// LSP-17108: the reply composer (`ref="replyBoxAddComment"`) only renders when
			// `showReplyBox && !isEditing && !isViewOnly` (see the template), so the ref is
			// legitimately absent whenever isViewOnly or isEditing is true at close time — a
			// view-only user closing an already-open reply box, or the CloseReplies EventBus
			// listener / delete-comment's forced-close path firing while isEditing is true.
			// Before this fix, closing in any of those states threw
			// `Cannot read properties of undefined (reading 'clearComment')`, which the old
			// single shared catch mislabeled with the fetch-specific "loading replies" toast —
			// on exit, not entry, matching the reported symptom exactly. A missing/throwing
			// composer cleanup is not user-actionable (the close already happened), so this
			// logs instead of toasting and always lets the close proceed.
			closeReplyComposer() {
				const replyBoxAddComment = this.$refs.replyBoxAddComment;
				if (!replyBoxAddComment) {
					// Expected, documented state (isViewOnly or isEditing legitimately excludes the
					// composer from the template) — logWarn, not logError.
					logWarn("[CommentAction] openReplyBox close: replyBoxAddComment ref is absent, skipping clearComment()", {
						component: "CommentAction",
						method: "openReplyBox",
						isViewOnly: this.isViewOnly,
						isEditing: this.isEditing,
						commentId: this.commentData?.id
					});
					return;
				}
				try {
					replyBoxAddComment.clearComment();
				} catch (error) {
					// A genuine anomaly (the ref exists but its own cleanup threw) — logError, a
					// louder severity than the expected-absence case above.
					logError("[CommentAction] openReplyBox close: replyBoxAddComment.clearComment() threw, continuing close", error, {
						component: "CommentAction",
						method: "openReplyBox",
						commentId: this.commentData?.id
					});
				}
			},
			onCommentEdited(editedComment) {
				this.$emit("comment-edited", editedComment);
			}
		}
	};
</script>

<style scoped>
	.text-150 {
		max-width: 150px;
	}
	.hover-item {
		transition: background-color 0.3s ease;
	}

	.hover-item:hover {
		background-color: #f5f5f5;
	}

	.no-pointer-events {
		pointer-events: none;
	}
	.v-list-item {
		min-height: 0;
		padding: 0px 8px 0px 0px !important;
	}
	.date {
		font-size: 0.8rem;
		color: #999;
		margin-left: 10px;
	}
	.team-member {
		font-size: 0.8rem;
	}
	.v-list-item__content {
		padding: 0 !important;
	}
	.mention {
		color: var(--mention-comment);
	}
	.number-container {
		font-size: 0.8rem;
		margin-bottom: 0rem;
		width: 100%;
		margin-top: 0px !important;
	}
	.comment-row {
		margin-top: 10px;
	}

	.v-btn:hover {
		background-color: transparent;
	}

	.replies-line {
		display: flex;
		align-items: center;
		color: black;
		opacity: 0.6;
		padding-bottom: 12px;
	}

	.replies-line .line {
		flex-grow: 1;
		height: 1px;
		background-color: black;
		opacity: 0.6;
		margin-left: 10px;
	}
	.updated-date {
		font-size: 0.8rem;
	}
	.row-updated {
		background-color: #f5f5f5;
	}

	.comment-name {
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.2 !important;
	}

	.comment-name .body {
		white-space: pre-line;
	}

	.comment-size {
		max-width: calc(100% - 112px) !important;
	}

	.heading {
		font-family: "Inter Tight";
		font-size: 1rem;
		font-style: normal;
		font-weight: 600;
		height: 36px;
	}

	.comment-card {
		margin-bottom: 5px;
	}

	.height-full {
		height: 100%;
	}

	.replies {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.replies-container-mobile {
		flex: 1 1 auto;
		overflow-y: auto;
	}

	.reply-and-replies {
		flex: 1;
		min-height: 0;
	}

	.heading-mobile {
		font-size: 1.25rem !important;
	}

	.editing-comment .v-list-item__content {
		overflow: visible;
	}
</style>
